import React from 'react';
import Box from '@mui/material/Box';
import {SvgProps} from '../../helpers/type';

const Shield = ({className, sx}: SvgProps): JSX.Element => {
    return (
        <Box
            component="svg"
            viewBox="0 0 65 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            sx={sx}
        >
            <rect x="0.5" y="1.43506" width="63" height="63" rx="31.5" fill="#F9F4F6" />
            <path
                d="M32 18.8223L19 24.6V33.2667C19 41.2834 24.5467 48.78 32 50.6C39.4533 48.78 45 41.2834 45 33.2667V24.6L32 18.8223ZM29.1111 41.9334L23.3333 36.1556L25.37 34.1189L29.1111 37.8456L38.63 28.3267L40.6667 30.3778L29.1111 41.9334Z"
                fill="#AD6E90"
            />
            <rect x="0.5" y="1.43506" width="63" height="63" rx="31.5" stroke="#EDE1E8" />
        </Box>
    );
};

export default Shield;
